(() => {
	const parser = new DOMParser();

	function init() {
		const $orders = $('#orders');
		const $content = $('#orders-content');
		const $heading = $('#orders-heading');
		const $btn = $('#orders-btn');

		$btn.on('click', async () => {
			const to = $btn.attr('data-switch-to');
			let url = `${ROOT}account/`;

			if (to === 'past-orders') {
				url += '?past-orders=true';
			}

			await hideOrders();
			$orders.addClass('-loading');

			const data = await ajax('GET', url);
			const newDoc = parser.parseFromString(data, 'text/html');
			const newContent = newDoc.querySelector('#orders-content');
			const newHeading = newDoc.querySelector('#orders-heading');
			const newBtn = newDoc.querySelector('#orders-btn');

			const height = $content.outerHeight();

			$content.html(newContent.innerHTML);
			$heading.html(newHeading.innerHTML);
			$btn.html(newBtn.innerHTML);
			$btn.attr('data-switch-to', newBtn.dataset.switchTo);

			$orders.removeClass('-loading');
			await showOrders(height);
		});
	}

	async function hideOrders() {
		await gsap.to('#orders-content', {
			duration: 0.33,
			opacity: 0,
			x: -50
		});
	}

	async function showOrders(height) {
		await gsap
			.timeline()
			.from('#orders-content', {
				duration: 0.33,
				clearProps: 'height',
				height: height
			})
			.to('#orders-content', {
				duration: 0.33,
				opacity: 1,
				x: 0
			});
	}

	// Events
	// ----------------------------------------

	$DOC.ready(() => {
		if ($BODY.hasClass('account-page')) init();
	});

	$WINDOW.on('page:load-completed', (e) => {
		if ($BODY.hasClass('account-page')) init();
	});
})();
